// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.statistical_test */
enum StatisticalTest {
  proportion_z = 'proportion_z',
  chi2 = 'chi2',
  fisher = 'fisher',
  sekhon = 'sekhon',
  wilcox = 'wilcox',
  ks = 'ks',
  t = 't',
  deseq2 = 'deseq2',
};

export default StatisticalTest;
